import { render, staticRenderFns } from "./GamesPermissionComponent.vue?vue&type=template&id=6417b5ce&scoped=true&"
import script from "./GamesPermissionComponent.vue?vue&type=script&lang=js&"
export * from "./GamesPermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./GamesPermissionComponent.vue?vue&type=style&index=0&id=6417b5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6417b5ce",
  null
  
)

export default component.exports